import(/* webpackMode: "eager" */ "/var/www/vhosts/dailyneedsproducts.com/httpdocs/src/app/contact/page.tsx");
